import type { GridApiPremium } from '@mui/x-data-grid-premium';
import type { RefObject } from 'react';
import { createContext } from 'react';
import type { DataGridActionsContextType } from './types';

export const DataGridActionsContext = createContext<DataGridActionsContextType>({
    apiRef: { current: null } as RefObject<GridApiPremium>,
    entityName: undefined,
    feature: '',
    activeRow: undefined,
    isRowValid: undefined,
    onEdit: undefined,
    onShare: undefined,
    enableInlineEditing: false,
    enableInlineDelete: false,
    onDelete: undefined,
    onDeleteHandle: undefined,
    copyTooltipTitle: '',
    onCopy: undefined,
    onActivateOrInactivateHandle: undefined,
    customActions: [],
    customRowActions: [],
    isMobile: false,
    actionLabels: {
        saveLabel: '',
        cancelLabel: '',
        editLabel: '',
        shareLabel: '',
        copyLabel: '',
        deleteLabel: ''
    },
    handleEditClick: undefined,
    handleEditCommit: undefined,
    handleEditCancel: undefined,
    handleDeleteClick: undefined,
    hideEditActionWhenInlineEditing: false
});
